import Skycon from "@/components/Skycon/Skycon";
import { Chrome } from "vue-color";
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import config from "../../../config";
import DataModal from "../components/DataModal";

export default {
  name: "slider",
  components: {
    Skycon,
    Chrome,
    vSelect,
    DatePicker,
    DataModal,
  },
  data() {
    return {
      data: [],
      columnsDatatable: [
        "no",
        "title",
        "description",
        "created_at",
        "updated_at",
        "aksi",
      ],
      tableOptions: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: "", count: "", limit: "" },
        columnsClasses: { no: "width-100", description: "text-wrap" },
        skin: "table table-striped",
        sortIcon: {
          base: "fa text-muted",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
      },
      editData: null,
      imagesUrl: [],
    };
  },
  computed: {
    dataTable() {
      return this.data.sort((a, b) => a.id - b.id).reduce((acc, item, idx) => [
        ...acc,
        {
          ...item,
          index: idx,
          no: idx + 1,
        },
      ], []);
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await axios.get(
        config.webprofileApiUrl + "/company-profile/home"
      );

      if (res.data) {
        this.data = res.data;
      }
    },
    handleEdit(index) {
      this.editData = this.dataTable[index];
    },
    async handleSaveEdit(payload) {
      const id = this.editData.id;

      try {
        let bodyFormData = new FormData();

        bodyFormData.append("title", payload[0].value);
        bodyFormData.append("description", payload[1].value);

        await axios({
          method: "patch",
          url: config.webprofileApiUrl + `/company-profile/home/${id}`,
          data: bodyFormData,
          headers: { "Content-Type": "multipart/form-data" },
        });
        
        this.$toasted.success("Berhasil Disimpan");
      } catch (err) {
        this.$toasted.error("Gagal Disimpan");
      } finally {
        this.getData();
      }
    },
    async handleDelete(index) {
      const id = this.dataTable[index].id;

      if (confirm("Are you sure to delete?")) {
        try {
          await axios({
            method: "delete",
            url: config.webprofileApiUrl + `/company-profile/home/${id}`,
            headers: { "Content-Type": "multipart/form-data" },
          });

          this.$toasted.success("Berhasil Dihapus");
        } catch (err) {
          this.$toasted.error("Gagal Dihapus");
        } finally {
          this.getData();
        }
      }
    },
    async handleSaveAdd(payload) {
      try {
        let bodyFormData = new FormData();

        bodyFormData.append("title", payload[0].value);
        bodyFormData.append("description", payload[1].value);

        await axios({
          method: "post",
          url: config.webprofileApiUrl + "/company-profile/home",
          data: bodyFormData,
          headers: { "Content-Type": "multipart/form-data" },
        });

        this.$toasted.success("Berhasil Ditambahkan");
      } catch (err) {
        this.$toasted.error("Gagal Ditambahkan");
      } finally {
        this.getData();
      }
    },
  },
};
